// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/survey_report.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreditSource } from "./credit_pb";
import { file_api_proto_v1_credit } from "./credit_pb";
import type { DealFile } from "./deal_file_pb";
import { file_api_proto_v1_deal_file } from "./deal_file_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/survey_report.proto.
 */
export const file_api_proto_v1_survey_report: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_credit, file_api_proto_v1_deal_file, file_google_protobuf_timestamp]);

/**
 * 画像プールの統合アイテム
 *
 * @generated from message api_proto.v1.PoolImage
 */
export type PoolImage = Message<"api_proto.v1.PoolImage"> & {
  /**
   * 元テーブルのID
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * presigned URL
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * 表示名
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: api_proto.v1.PoolImageSourceType source_type = 4;
   */
  sourceType: PoolImageSourceType;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * MIME タイプ（案件ファイル由来のときだけ入る。AIカラー結果画像では空）。
   * 写真の回転（issue #2599）が扱えない形式（HEIC 等）のボタンを画面で出し分けるために返す。
   * プールは HEIC/HEIF も含むが回転は JPEG / PNG / GIF / WebP だけなので、
   * これが無いと「押すと必ず失敗するボタン」が出てしまう。
   *
   * @generated from field: string content_type = 6;
   */
  contentType: string;
};

/**
 * Describes the message api_proto.v1.PoolImage.
 * Use `create(PoolImageSchema)` to create a new message.
 */
export const PoolImageSchema: GenMessage<PoolImage> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 0);

/**
 * 現場調査報告書
 *
 * @generated from message api_proto.v1.SurveyReport
 */
export type SurveyReport = Message<"api_proto.v1.SurveyReport"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * 調査担当者
   *
   * @generated from field: string surveyor = 3;
   */
  surveyor: string;

  /**
   * 調査日
   *
   * @generated from field: google.protobuf.Timestamp survey_date = 4;
   */
  surveyDate?: Timestamp;

  /**
   * 結論（UI上は「結論」と表示。旧称: 全体説明）
   *
   * @generated from field: string overall_explanation = 5;
   */
  overallExplanation: string;

  /**
   * [deprecated] 提案工事名（複数提案構造へ移行済み、batch 移行後に削除予定）
   *
   * @generated from field: string proposal_name = 6;
   */
  proposalName: string;

  /**
   * [deprecated] 提案詳細（複数提案構造へ移行済み、batch 移行後に削除予定）
   *
   * @generated from field: string proposal_details = 7;
   */
  proposalDetails: string;

  /**
   * 部位別調査データ
   *
   * @generated from field: repeated api_proto.v1.SurveyPart parts = 8;
   */
  parts: SurveyPart[];

  /**
   * [deprecated] 推奨工事リスト（複数提案構造へ移行済み、batch 移行後に削除予定）
   *
   * @generated from field: repeated string recommended_works = 9;
   */
  recommendedWorks: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * 提案セクション（複数案）
   *
   * @generated from field: repeated api_proto.v1.SurveyProposal proposals = 13;
   */
  proposals: SurveyProposal[];

  /**
   * 担当者からのメッセージ（訴求用、人柄を出す手書き文章）
   *
   * @generated from field: string staff_message = 14;
   */
  staffMessage: string;

  /**
   * PDFへの会社ロゴ表示フラグ（表紙のコンテンツ部分と、表紙以外のページのヘッダーに適用）
   *
   * @generated from field: bool show_logo_in_header = 15;
   */
  showLogoInHeader: boolean;

  /**
   * 表紙の書類タイトル（空文字ならフロント側でデフォルト「現場調査報告書」表示）
   *
   * @generated from field: string document_title = 16;
   */
  documentTitle: string;

  /**
   * 表紙画像（deal_file 由来）
   *
   * @generated from field: optional int64 cover_deal_file_id = 17;
   */
  coverDealFileId?: bigint;

  /**
   * 表紙画像（AIカラーシミュレーション結果画像由来）
   *
   * @generated from field: optional int64 cover_color_simulation_image_id = 18;
   */
  coverColorSimulationImageId?: bigint;

  /**
   * 表紙画像 表示用統合（presigned URL含む）
   *
   * @generated from field: optional api_proto.v1.PoolImage cover_pool_image = 19;
   */
  coverPoolImage?: PoolImage;

  /**
   * 部位別ランクをPDF/DOCX出力で非表示にするか（編集UI/AIには影響なし）
   *
   * @generated from field: bool hide_ranks_in_output = 20;
   */
  hideRanksInOutput: boolean;
};

/**
 * Describes the message api_proto.v1.SurveyReport.
 * Use `create(SurveyReportSchema)` to create a new message.
 */
export const SurveyReportSchema: GenMessage<SurveyReport> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 1);

/**
 * 部位別調査データ
 *
 * @generated from message api_proto.v1.SurveyPart
 */
export type SurveyPart = Message<"api_proto.v1.SurveyPart"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 表示順
   *
   * @generated from field: int32 sort_order = 2;
   */
  sortOrder: number;

  /**
   * 見出し
   *
   * @generated from field: string heading = 3;
   */
  heading: string;

  /**
   * 部位名
   *
   * @generated from field: string part_name = 4;
   */
  partName: string;

  /**
   * 使用部材
   *
   * @generated from field: string material_name = 5;
   */
  materialName: string;

  /**
   * 調査方法
   *
   * @generated from field: repeated string survey_method = 6;
   */
  surveyMethod: string[];

  /**
   * 現状説明
   *
   * @generated from field: string condition_description = 7;
   */
  conditionDescription: string;

  /**
   * 状態ランク（1-5）
   *
   * @generated from field: int32 rank = 8;
   */
  rank: number;

  /**
   * 選択された劣化症状
   *
   * @generated from field: repeated string selected_defects = 9;
   */
  selectedDefects: string[];

  /**
   * 画像リスト
   *
   * @generated from field: repeated api_proto.v1.SurveyPartImage images = 10;
   */
  images: SurveyPartImage[];

  /**
   * 想定されるリスク
   *
   * @generated from field: string risk_assessment = 11;
   */
  riskAssessment: string;

  /**
   * 推奨される対応
   *
   * @generated from field: string recommended_action = 12;
   */
  recommendedAction: string;

  /**
   * 写真一覧のレイアウト（部位単位）
   *
   * @generated from field: api_proto.v1.PhotoLayoutMode photo_layout_mode = 13;
   */
  photoLayoutMode: PhotoLayoutMode;

  /**
   * フロントが発番する部位の識別子。id は保存のたびに変わるため、生成ログとの突合に使う
   *
   * @generated from field: string part_key = 14;
   */
  partKey: string;
};

/**
 * Describes the message api_proto.v1.SurveyPart.
 * Use `create(SurveyPartSchema)` to create a new message.
 */
export const SurveyPartSchema: GenMessage<SurveyPart> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 2);

/**
 * 提案セクションのデータ（複数案の比較資料用）
 *
 * @generated from message api_proto.v1.SurveyProposal
 */
export type SurveyProposal = Message<"api_proto.v1.SurveyProposal"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 表示順
   *
   * @generated from field: int32 sort_order = 2;
   */
  sortOrder: number;

  /**
   * 案の名称（必須）
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 概算見積もり金額（税込円、未入力は非表示）
   *
   * @generated from field: optional int64 estimated_amount = 4;
   */
  estimatedAmount?: bigint;

  /**
   * 使用する部材
   *
   * @generated from field: string materials = 5;
   */
  materials: string;

  /**
   * 工事内容（必須）
   *
   * @generated from field: string construction_content = 6;
   */
  constructionContent: string;

  /**
   * メリット
   *
   * @generated from field: string merit = 7;
   */
  merit: string;

  /**
   * デメリット
   *
   * @generated from field: string demerit = 8;
   */
  demerit: string;

  /**
   * 提案画像（UI上は最大1枚）
   *
   * @generated from field: repeated api_proto.v1.SurveyProposalImage images = 9;
   */
  images: SurveyProposalImage[];
};

/**
 * Describes the message api_proto.v1.SurveyProposal.
 * Use `create(SurveyProposalSchema)` to create a new message.
 */
export const SurveyProposalSchema: GenMessage<SurveyProposal> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 3);

/**
 * 提案画像データ
 *
 * @generated from message api_proto.v1.SurveyProposalImage
 */
export type SurveyProposalImage = Message<"api_proto.v1.SurveyProposalImage"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 deal_file_id = 2;
   */
  dealFileId: bigint;

  /**
   * @generated from field: int32 sort_order = 3;
   */
  sortOrder: number;

  /**
   * 画像ファイル情報
   *
   * @generated from field: api_proto.v1.DealFile deal_file = 4;
   */
  dealFile?: DealFile;

  /**
   * @generated from field: optional int64 color_simulation_image_id = 5;
   */
  colorSimulationImageId?: bigint;

  /**
   * 表示用統合画像情報
   *
   * @generated from field: optional api_proto.v1.PoolImage pool_image = 6;
   */
  poolImage?: PoolImage;

  /**
   * 画像キャプション
   *
   * @generated from field: string description = 7;
   */
  description: string;
};

/**
 * Describes the message api_proto.v1.SurveyProposalImage.
 * Use `create(SurveyProposalImageSchema)` to create a new message.
 */
export const SurveyProposalImageSchema: GenMessage<SurveyProposalImage> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 4);

/**
 * 部位画像データ
 *
 * @generated from message api_proto.v1.SurveyPartImage
 */
export type SurveyPartImage = Message<"api_proto.v1.SurveyPartImage"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 deal_file_id = 2;
   */
  dealFileId: bigint;

  /**
   * @generated from field: int32 sort_order = 3;
   */
  sortOrder: number;

  /**
   * 注釈付き画像のR2キー（オプション）
   *
   * @generated from field: string annotated_r2_key = 4;
   */
  annotatedR2Key: string;

  /**
   * 画像ファイル情報
   *
   * @generated from field: api_proto.v1.DealFile deal_file = 5;
   */
  dealFile?: DealFile;

  /**
   * AIカラーシミュレーション結果画像ID
   *
   * @generated from field: optional int64 color_simulation_image_id = 6;
   */
  colorSimulationImageId?: bigint;

  /**
   * 表示用統合画像情報
   *
   * @generated from field: optional api_proto.v1.PoolImage pool_image = 7;
   */
  poolImage?: PoolImage;

  /**
   * 画像キャプション（説明文）
   *
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * 見出し画像フラグ（セクションページに大きく表示）
   *
   * @generated from field: bool is_hero = 9;
   */
  isHero: boolean;
};

/**
 * Describes the message api_proto.v1.SurveyPartImage.
 * Use `create(SurveyPartImageSchema)` to create a new message.
 */
export const SurveyPartImageSchema: GenMessage<SurveyPartImage> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 5);

/**
 * 現場調査報告書取得リクエスト
 *
 * @generated from message api_proto.v1.GetSurveyReportRequest
 */
export type GetSurveyReportRequest = Message<"api_proto.v1.GetSurveyReportRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.GetSurveyReportRequest.
 * Use `create(GetSurveyReportRequestSchema)` to create a new message.
 */
export const GetSurveyReportRequestSchema: GenMessage<GetSurveyReportRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 6);

/**
 * 現場調査報告書取得レスポンス
 *
 * @generated from message api_proto.v1.GetSurveyReportResponse
 */
export type GetSurveyReportResponse = Message<"api_proto.v1.GetSurveyReportResponse"> & {
  /**
   * @generated from field: api_proto.v1.SurveyReport report = 1;
   */
  report?: SurveyReport;

  /**
   * 報告書が存在するかどうか
   *
   * @generated from field: bool exists = 2;
   */
  exists: boolean;
};

/**
 * Describes the message api_proto.v1.GetSurveyReportResponse.
 * Use `create(GetSurveyReportResponseSchema)` to create a new message.
 */
export const GetSurveyReportResponseSchema: GenMessage<GetSurveyReportResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 7);

/**
 * 現場調査報告書保存リクエスト
 *
 * @generated from message api_proto.v1.SaveSurveyReportRequest
 */
export type SaveSurveyReportRequest = Message<"api_proto.v1.SaveSurveyReportRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: string surveyor = 2;
   */
  surveyor: string;

  /**
   * @generated from field: google.protobuf.Timestamp survey_date = 3;
   */
  surveyDate?: Timestamp;

  /**
   * 結論
   *
   * @generated from field: string overall_explanation = 4;
   */
  overallExplanation: string;

  /**
   * [deprecated] 旧構造、batch 移行後削除予定
   *
   * @generated from field: string proposal_name = 5;
   */
  proposalName: string;

  /**
   * [deprecated] 旧構造、batch 移行後削除予定
   *
   * @generated from field: string proposal_details = 6;
   */
  proposalDetails: string;

  /**
   * @generated from field: repeated api_proto.v1.SaveSurveyPartRequest parts = 7;
   */
  parts: SaveSurveyPartRequest[];

  /**
   * [deprecated] 旧構造、batch 移行後削除予定
   *
   * @generated from field: repeated string recommended_works = 8;
   */
  recommendedWorks: string[];

  /**
   * 提案セクション（複数案）
   *
   * @generated from field: repeated api_proto.v1.SaveSurveyProposalRequest proposals = 10;
   */
  proposals: SaveSurveyProposalRequest[];

  /**
   * 担当者からのメッセージ
   *
   * @generated from field: string staff_message = 11;
   */
  staffMessage: string;

  /**
   * PDFへの会社ロゴ表示フラグ
   *
   * @generated from field: bool show_logo_in_header = 12;
   */
  showLogoInHeader: boolean;

  /**
   * 表紙の書類タイトル
   *
   * @generated from field: string document_title = 13;
   */
  documentTitle: string;

  /**
   * 表紙画像（deal_file）
   *
   * @generated from field: optional int64 cover_deal_file_id = 14;
   */
  coverDealFileId?: bigint;

  /**
   * 表紙画像（AIカラー結果）
   *
   * @generated from field: optional int64 cover_color_simulation_image_id = 15;
   */
  coverColorSimulationImageId?: bigint;

  /**
   * 部位別ランクを PDF/DOCX 出力で非表示にするか
   *
   * @generated from field: bool hide_ranks_in_output = 16;
   */
  hideRanksInOutput: boolean;
};

/**
 * Describes the message api_proto.v1.SaveSurveyReportRequest.
 * Use `create(SaveSurveyReportRequestSchema)` to create a new message.
 */
export const SaveSurveyReportRequestSchema: GenMessage<SaveSurveyReportRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 8);

/**
 * 部位保存リクエスト
 *
 * @generated from message api_proto.v1.SaveSurveyPartRequest
 */
export type SaveSurveyPartRequest = Message<"api_proto.v1.SaveSurveyPartRequest"> & {
  /**
   * 既存の場合はID指定、新規の場合は0
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int32 sort_order = 2;
   */
  sortOrder: number;

  /**
   * @generated from field: string heading = 3;
   */
  heading: string;

  /**
   * @generated from field: string part_name = 4;
   */
  partName: string;

  /**
   * @generated from field: string material_name = 5;
   */
  materialName: string;

  /**
   * @generated from field: repeated string survey_method = 6;
   */
  surveyMethod: string[];

  /**
   * @generated from field: string condition_description = 7;
   */
  conditionDescription: string;

  /**
   * @generated from field: int32 rank = 8;
   */
  rank: number;

  /**
   * @generated from field: repeated string selected_defects = 9;
   */
  selectedDefects: string[];

  /**
   * @generated from field: repeated api_proto.v1.SaveSurveyPartImageRequest images = 10;
   */
  images: SaveSurveyPartImageRequest[];

  /**
   * @generated from field: string risk_assessment = 11;
   */
  riskAssessment: string;

  /**
   * @generated from field: string recommended_action = 12;
   */
  recommendedAction: string;

  /**
   * 写真一覧のレイアウト（部位単位）
   *
   * @generated from field: api_proto.v1.PhotoLayoutMode photo_layout_mode = 13;
   */
  photoLayoutMode: PhotoLayoutMode;

  /**
   * フロントが発番する部位の識別子。空または64文字超は未設定として扱う
   *
   * @generated from field: string part_key = 14;
   */
  partKey: string;
};

/**
 * Describes the message api_proto.v1.SaveSurveyPartRequest.
 * Use `create(SaveSurveyPartRequestSchema)` to create a new message.
 */
export const SaveSurveyPartRequestSchema: GenMessage<SaveSurveyPartRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 9);

/**
 * 提案保存リクエスト
 *
 * @generated from message api_proto.v1.SaveSurveyProposalRequest
 */
export type SaveSurveyProposalRequest = Message<"api_proto.v1.SaveSurveyProposalRequest"> & {
  /**
   * 既存の場合はID指定、新規の場合は0
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int32 sort_order = 2;
   */
  sortOrder: number;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional int64 estimated_amount = 4;
   */
  estimatedAmount?: bigint;

  /**
   * @generated from field: string materials = 5;
   */
  materials: string;

  /**
   * @generated from field: string construction_content = 6;
   */
  constructionContent: string;

  /**
   * @generated from field: string merit = 7;
   */
  merit: string;

  /**
   * @generated from field: string demerit = 8;
   */
  demerit: string;

  /**
   * @generated from field: repeated api_proto.v1.SaveSurveyProposalImageRequest images = 9;
   */
  images: SaveSurveyProposalImageRequest[];
};

/**
 * Describes the message api_proto.v1.SaveSurveyProposalRequest.
 * Use `create(SaveSurveyProposalRequestSchema)` to create a new message.
 */
export const SaveSurveyProposalRequestSchema: GenMessage<SaveSurveyProposalRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 10);

/**
 * 提案画像保存リクエスト
 *
 * @generated from message api_proto.v1.SaveSurveyProposalImageRequest
 */
export type SaveSurveyProposalImageRequest = Message<"api_proto.v1.SaveSurveyProposalImageRequest"> & {
  /**
   * @generated from field: int64 deal_file_id = 1;
   */
  dealFileId: bigint;

  /**
   * @generated from field: int32 sort_order = 2;
   */
  sortOrder: number;

  /**
   * @generated from field: optional int64 color_simulation_image_id = 3;
   */
  colorSimulationImageId?: bigint;

  /**
   * @generated from field: string description = 4;
   */
  description: string;
};

/**
 * Describes the message api_proto.v1.SaveSurveyProposalImageRequest.
 * Use `create(SaveSurveyProposalImageRequestSchema)` to create a new message.
 */
export const SaveSurveyProposalImageRequestSchema: GenMessage<SaveSurveyProposalImageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 11);

/**
 * 部位画像保存リクエスト
 *
 * @generated from message api_proto.v1.SaveSurveyPartImageRequest
 */
export type SaveSurveyPartImageRequest = Message<"api_proto.v1.SaveSurveyPartImageRequest"> & {
  /**
   * @generated from field: int64 deal_file_id = 1;
   */
  dealFileId: bigint;

  /**
   * @generated from field: int32 sort_order = 2;
   */
  sortOrder: number;

  /**
   * @generated from field: string annotated_r2_key = 3;
   */
  annotatedR2Key: string;

  /**
   * AIカラーシミュレーション結果画像ID
   *
   * @generated from field: optional int64 color_simulation_image_id = 4;
   */
  colorSimulationImageId?: bigint;

  /**
   * 画像キャプション（説明文）
   *
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * 見出し画像フラグ
   *
   * @generated from field: bool is_hero = 6;
   */
  isHero: boolean;
};

/**
 * Describes the message api_proto.v1.SaveSurveyPartImageRequest.
 * Use `create(SaveSurveyPartImageRequestSchema)` to create a new message.
 */
export const SaveSurveyPartImageRequestSchema: GenMessage<SaveSurveyPartImageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 12);

/**
 * 現場調査報告書保存レスポンス
 *
 * @generated from message api_proto.v1.SaveSurveyReportResponse
 */
export type SaveSurveyReportResponse = Message<"api_proto.v1.SaveSurveyReportResponse"> & {
  /**
   * @generated from field: api_proto.v1.SurveyReport report = 1;
   */
  report?: SurveyReport;

  /**
   * 新規作成時の課金元（design-6.6-notifications.md §2）。新規作成以外の保存（編集・再利用）は
   * 無課金のため CREDIT_SOURCE_NONE。
   *
   * @generated from field: api_proto.v1.CreditSource credit_source = 2;
   */
  creditSource: CreditSource;
};

/**
 * Describes the message api_proto.v1.SaveSurveyReportResponse.
 * Use `create(SaveSurveyReportResponseSchema)` to create a new message.
 */
export const SaveSurveyReportResponseSchema: GenMessage<SaveSurveyReportResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 13);

/**
 * 現場調査報告書削除リクエスト
 *
 * @generated from message api_proto.v1.DeleteSurveyReportRequest
 */
export type DeleteSurveyReportRequest = Message<"api_proto.v1.DeleteSurveyReportRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteSurveyReportRequest.
 * Use `create(DeleteSurveyReportRequestSchema)` to create a new message.
 */
export const DeleteSurveyReportRequestSchema: GenMessage<DeleteSurveyReportRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 14);

/**
 * 案件画像一覧取得リクエスト（画像系ファイルのみ）
 *
 * @generated from message api_proto.v1.GetDealImagesRequest
 */
export type GetDealImagesRequest = Message<"api_proto.v1.GetDealImagesRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealImagesRequest.
 * Use `create(GetDealImagesRequestSchema)` to create a new message.
 */
export const GetDealImagesRequestSchema: GenMessage<GetDealImagesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 15);

/**
 * 案件画像一覧取得レスポンス
 *
 * @generated from message api_proto.v1.GetDealImagesResponse
 */
export type GetDealImagesResponse = Message<"api_proto.v1.GetDealImagesResponse"> & {
  /**
   * 統合画像プール（deal_files + AIカラーシミュレーション結果画像）
   *
   * @generated from field: repeated api_proto.v1.PoolImage images = 1;
   */
  images: PoolImage[];
};

/**
 * Describes the message api_proto.v1.GetDealImagesResponse.
 * Use `create(GetDealImagesResponseSchema)` to create a new message.
 */
export const GetDealImagesResponseSchema: GenMessage<GetDealImagesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 16);

/**
 * AI執筆支援リクエスト
 *
 * @generated from message api_proto.v1.GenerateSurveyTextRequest
 */
export type GenerateSurveyTextRequest = Message<"api_proto.v1.GenerateSurveyTextRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * 生成対象フィールド: "overall_explanation"（=結論）, "condition_description", "condition_all"
   *
   * @generated from field: string target_field = 2;
   */
  targetField: string;

  /**
   * コンテキスト情報
   *
   * @generated from field: api_proto.v1.SurveyTextContext context = 3;
   */
  context?: SurveyTextContext;
};

/**
 * Describes the message api_proto.v1.GenerateSurveyTextRequest.
 * Use `create(GenerateSurveyTextRequestSchema)` to create a new message.
 */
export const GenerateSurveyTextRequestSchema: GenMessage<GenerateSurveyTextRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 17);

/**
 * AI執筆支援コンテキスト
 *
 * @generated from message api_proto.v1.SurveyTextContext
 */
export type SurveyTextContext = Message<"api_proto.v1.SurveyTextContext"> & {
  /**
   * 部位名（condition_description生成時）
   *
   * @generated from field: string part_name = 1;
   */
  partName: string;

  /**
   * 使用部材
   *
   * @generated from field: string material_name = 2;
   */
  materialName: string;

  /**
   * 調査方法
   *
   * @generated from field: repeated string survey_method = 3;
   */
  surveyMethod: string[];

  /**
   * 状態ランク
   *
   * @generated from field: int32 rank = 4;
   */
  rank: number;

  /**
   * 選択された劣化症状
   *
   * @generated from field: repeated string selected_defects = 5;
   */
  selectedDefects: string[];

  /**
   * 全部位データ（overall_explanation 生成時）
   *
   * @generated from field: repeated api_proto.v1.SurveyPart all_parts = 6;
   */
  allParts: SurveyPart[];

  /**
   * 劣化症状の詳細情報（mechanism, recommendation）
   *
   * @generated from field: repeated api_proto.v1.DefectDetail defect_details = 7;
   */
  defectDetails: DefectDetail[];

  /**
   * 全提案データ（overall_explanation = 結論生成時に比較対象として渡す）
   *
   * @generated from field: repeated api_proto.v1.SurveyProposal all_proposals = 8;
   */
  allProposals: SurveyProposal[];

  /**
   * 生成対象の部位の識別子（SurveyPart.part_key。部位単位の生成時）
   *
   * @generated from field: string part_key = 9;
   */
  partKey: string;
};

/**
 * Describes the message api_proto.v1.SurveyTextContext.
 * Use `create(SurveyTextContextSchema)` to create a new message.
 */
export const SurveyTextContextSchema: GenMessage<SurveyTextContext> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 18);

/**
 * 劣化症状の詳細情報
 *
 * @generated from message api_proto.v1.DefectDetail
 */
export type DefectDetail = Message<"api_proto.v1.DefectDetail"> & {
  /**
   * 劣化症状名
   *
   * @generated from field: string defect = 1;
   */
  defect: string;

  /**
   * 発生メカニズム・原因
   *
   * @generated from field: string mechanism = 2;
   */
  mechanism: string;

  /**
   * 推奨工事
   *
   * @generated from field: string recommendation = 3;
   */
  recommendation: string;
};

/**
 * Describes the message api_proto.v1.DefectDetail.
 * Use `create(DefectDetailSchema)` to create a new message.
 */
export const DefectDetailSchema: GenMessage<DefectDetail> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 19);

/**
 * AI執筆支援レスポンス
 *
 * @generated from message api_proto.v1.GenerateSurveyTextResponse
 */
export type GenerateSurveyTextResponse = Message<"api_proto.v1.GenerateSurveyTextResponse"> & {
  /**
   * @generated from field: string generated_text = 1;
   */
  generatedText: string;

  /**
   * 想定されるリスク（condition_all時）
   *
   * @generated from field: string risk_assessment = 2;
   */
  riskAssessment: string;

  /**
   * 推奨される対応（condition_all時）
   *
   * @generated from field: string recommended_action = 3;
   */
  recommendedAction: string;
};

/**
 * Describes the message api_proto.v1.GenerateSurveyTextResponse.
 * Use `create(GenerateSurveyTextResponseSchema)` to create a new message.
 */
export const GenerateSurveyTextResponseSchema: GenMessage<GenerateSurveyTextResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 20);

/**
 * 企業横断の現地調査報告書一覧リクエスト（決定 72）
 *
 * @generated from message api_proto.v1.ListCompanySurveyReportsRequest
 */
export type ListCompanySurveyReportsRequest = Message<"api_proto.v1.ListCompanySurveyReportsRequest"> & {
  /**
   * 報告書タイトル・案件名・顧客名の部分一致
   *
   * @generated from field: string free_word = 1;
   */
  freeWord: string;

  /**
   * 調査担当者名。survey_reports.surveyor はスタッフ氏名の文字列なので ID ではなく名前で完全一致。空 = 指定なし
   *
   * @generated from field: string surveyor = 2;
   */
  surveyor: string;

  /**
   * 状態ランク（1-5。1 が最悪・5 が最良）。0 = 指定なし
   *
   * @generated from field: int32 condition_rank = 3;
   */
  conditionRank: number;

  /**
   * 調査日の下限（YYYY-MM-DD）。空 = 指定なし
   *
   * @generated from field: string survey_date_from = 4;
   */
  surveyDateFrom: string;

  /**
   * 調査日の上限（YYYY-MM-DD）。空 = 指定なし
   *
   * @generated from field: string survey_date_to = 5;
   */
  surveyDateTo: string;

  /**
   * 1 始まり。0 以下は 1 として扱う
   *
   * @generated from field: int32 page = 6;
   */
  page: number;

  /**
   * 既定 20・上限 100
   *
   * @generated from field: int32 page_size = 7;
   */
  pageSize: number;
};

/**
 * Describes the message api_proto.v1.ListCompanySurveyReportsRequest.
 * Use `create(ListCompanySurveyReportsRequestSchema)` to create a new message.
 */
export const ListCompanySurveyReportsRequestSchema: GenMessage<ListCompanySurveyReportsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 21);

/**
 * 企業横断の現地調査報告書一覧レスポンス
 *
 * @generated from message api_proto.v1.ListCompanySurveyReportsResponse
 */
export type ListCompanySurveyReportsResponse = Message<"api_proto.v1.ListCompanySurveyReportsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CompanySurveyReportItem items = 1;
   */
  items: CompanySurveyReportItem[];

  /**
   * フィルタ適用後の総件数（ページング前）
   *
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message api_proto.v1.ListCompanySurveyReportsResponse.
 * Use `create(ListCompanySurveyReportsResponseSchema)` to create a new message.
 */
export const ListCompanySurveyReportsResponseSchema: GenMessage<ListCompanySurveyReportsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 22);

/**
 * 企業横断の現地調査報告書一覧の 1 行
 *
 * @generated from message api_proto.v1.CompanySurveyReportItem
 */
export type CompanySurveyReportItem = Message<"api_proto.v1.CompanySurveyReportItem"> & {
  /**
   * @generated from field: int64 report_id = 1;
   */
  reportId: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * deal_form_values の name（未設定は空）
   *
   * @generated from field: string deal_name = 3;
   */
  dealName: string;

  /**
   * customers.name（未設定は空）
   *
   * @generated from field: string customer_name = 4;
   */
  customerName: string;

  /**
   * survey_reports.document_title（未設定は空。既定表示はフロントが補う）
   *
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * 調査日（YYYY-MM-DD）。未設定は空
   *
   * @generated from field: string survey_date = 6;
   */
  surveyDate: string;

  /**
   * 調査担当者名（survey_reports.surveyor）
   *
   * @generated from field: string surveyor_name = 7;
   */
  surveyorName: string;

  /**
   * 部位ランクの最小値（= 最も悪い部位）。部位なし・全 NULL は 0
   *
   * @generated from field: int32 condition_rank = 8;
   */
  conditionRank: number;

  /**
   * 部位数
   *
   * @generated from field: int32 part_count = 9;
   */
  partCount: number;

  /**
   * 提案数
   *
   * @generated from field: int32 proposal_count = 10;
   */
  proposalCount: number;

  /**
   * RFC3339
   *
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;
};

/**
 * Describes the message api_proto.v1.CompanySurveyReportItem.
 * Use `create(CompanySurveyReportItemSchema)` to create a new message.
 */
export const CompanySurveyReportItemSchema: GenMessage<CompanySurveyReportItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_survey_report, 23);

/**
 * 画像プールのソース種別
 *
 * @generated from enum api_proto.v1.PoolImageSourceType
 */
export enum PoolImageSourceType {
  /**
   * @generated from enum value: POOL_IMAGE_SOURCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * deal_files テーブル由来
   *
   * @generated from enum value: POOL_IMAGE_SOURCE_TYPE_DEAL_FILE = 1;
   */
  DEAL_FILE = 1,

  /**
   * color_simulation_images テーブル由来（結果画像のみ）
   *
   * @generated from enum value: POOL_IMAGE_SOURCE_TYPE_COLOR_SIMULATION = 2;
   */
  COLOR_SIMULATION = 2,
}

/**
 * Describes the enum api_proto.v1.PoolImageSourceType.
 */
export const PoolImageSourceTypeSchema: GenEnum<PoolImageSourceType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_survey_report, 0);

/**
 * 写真一覧のレイアウトモード
 *
 * @generated from enum api_proto.v1.PhotoLayoutMode
 */
export enum PhotoLayoutMode {
  /**
   * 未指定（既定: GRID6）
   *
   * @generated from enum value: PHOTO_LAYOUT_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 6枚2カラム×3行（密度優先）
   *
   * @generated from enum value: PHOTO_LAYOUT_MODE_GRID6 = 1;
   */
  GRID6 = 1,

  /**
   * 2枚を大きく縦積み（視認性優先）
   *
   * @generated from enum value: PHOTO_LAYOUT_MODE_STACKED2 = 2;
   */
  STACKED2 = 2,
}

/**
 * Describes the enum api_proto.v1.PhotoLayoutMode.
 */
export const PhotoLayoutModeSchema: GenEnum<PhotoLayoutMode> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_survey_report, 1);

